module.exports = __webpack_public_path__ + "img/qt.c44519de.png";